module.exports = __webpack_public_path__ + "static/img/like_select.670a4888.png";